<form class="qualification-tab-form" [formGroup]="QualificationTab">
  <input type="hidden" formControlName="id">
  <div class="mt-5" style="margin-left: 100px; margin-right: 100px">
    <div class="row">
      <mat-form-field class="qualification-type-width">
        <mat-label class="boldlabel">Qualification Type</mat-label>
        <mat-select formControlName="qualificationType">
          <mat-option *ngFor="let rl of QualificationTypes" [value]="rl.id">
            {{rl?.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="col-4">
        <mat-form-field>
          <mat-label class="boldlabel">Entity Control #</mat-label>
          <input matInput (keypress)="fitlerECN($event)" placeholder="Entity Control" (focusout)="onEcnFocusOutEvent($event)" formControlName="entityControlNumber">
        </mat-form-field>
      </div>
      <div class="col-2" style="align-items: center">
        <a *ngIf="IsExternal" class="helplink" matTooltip="Entity control # is assigned by the Secretary of State.  This type of control number is assigned to every corporation, limited liability company, and limited partnership formed or qualified in Tennessee, as well as to any recorded registered names and reserved names for such business.">What is this?</a>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label class="boldlabel">FEIN</mat-label>
          <input matInput placeholder="##-#######" (focusout)="onFeinFocusOutEvent($event)" mask='00-0000000' formControlName="fein" value="">
        </mat-form-field>
      </div>
      <div class="col-2">
        <a *ngIf="IsExternal" matTooltip="An Employer Identification Number (EIN) is also known as a Federal Tax Identification Number and is used to identify a business entity.  The FEIN is a nine-digit number assigned by the IRS in the following format XX-XXXXXXX.  Businesses wishing to register for Workers’ Compensation Exemption require a FEIN.  Please contact the IRS at (800) 829-4933 for assistance regarding a FEIN.  A free service is also offered by the Internal Revenue Service to apply for a FEIN online at IRS.gov" class="helplink">What is this?</a>
      </div>
    </div>
    <div class="row mb-2">
      <a href="https://tncab.tnsos.gov/business-entity-search" target="_blank">Secretary of State Business Search</a>
    </div>
    <div class="row">
      <mat-form-field class="qualification-type-width">
        <mat-label class="boldlabel">Business Entity Name</mat-label>
        <input matInput placeholder="Business Entity Name" formControlName="filingEntityName" value="">
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutGap="50px" class="applicant-background-color">
      <span class='applicant-span'>Applicant</span>
    </div>
    <div class="row">
      <div class="col-6">
        <mat-form-field class="first-name-width">
          <mat-label class="boldlabel">First Name</mat-label>
          <input matInput placeholder="First Name" formControlName="firstName" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="birth-date-width">
          <input class="boldlabel" matInput [matDatepicker]="birthDatePicker" formControlName="birthDate"
            placeholder="Birth Date">
          <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <mat-form-field class="first-name-width">
          <mat-label>Middle Name</mat-label>
          <input matInput placeholder="Middle Name" formControlName="middleName" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="birth-date-width">
          <mat-label class="boldlabel">Last 4 SSN or SSA Control #</mat-label>
          <input matInput autocomplete="off" placeholder="Last 4 SSN or SSA Control #" mask='0000'
            formControlName="lastFourSocialSecurityNumber" value="">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <mat-form-field class="first-name-width">
          <mat-label class="boldlabel">Last Name</mat-label>
          <input matInput placeholder="Last Name" formControlName="lastName" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="birth-date-width">
          <mat-label>Suffix</mat-label>
          <input matInput autocomplete="off" placeholder="Suffix" 
            formControlName="nameSuffix" value="">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <mat-form-field class="phone-width">
          <mat-label class="boldlabel">Phone</mat-label>
          <input matInput placeholder="(###) ###-####" mask='(000) 000-0000' formControlName="contactPhone" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="phone-extension-width">
          <mat-label>Phone Extension</mat-label>
          <input matInput placeholder="Phone Extension" formControlName="contactPhoneExtension" value="">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <mat-form-field class="email-width">
        <mat-label class="boldlabel">Email</mat-label>
        <input type="email" matInput placeholder="Email"
          formControlName="contactEmail" value="">
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="email-width">
        <mat-label class="boldlabel">Confirm Email</mat-label>
        <input type="email"  [errorStateMatcher]="matcher" matInput
          formControlName="confirmEmail" placeholder="Confirm Email" value="">
        <mat-error *ngIf="QualificationTab.hasError('notSame')">
          Emails do not match
        </mat-error>
      </mat-form-field>
    </div>
  </div>

</form>
